// extracted by mini-css-extract-plugin
export var wrap = "Accordion-module--wrap--tYDuZ";
export var toggle = "Accordion-module--toggle--30aD2";
export var numbered = "Accordion-module--numbered--3fnYB";
export var flip = "Accordion-module--flip--3_9ZU";
export var collapser = "Accordion-module--collapser--DMgqM";
export var copy = "Accordion-module--copy--1TvBs";
export var open = "Accordion-module--open--3Wwr5";
export var close = "Accordion-module--close--25wCv";